import React, { useState, useContext } from 'react';
import styled from 'styled-components'
import Cancel from '@material-ui/icons/RemoveCircle';
import { cancelPortalUser, reactivatePortalUser } from '../../../../../api'
import { AuthContext } from '../../../../../auth-context'
// import { DashboardContext } from '../../../dashboard-context'
import Button from '../../../../../components/button'
import Modal from '../../../../../components/modal'
import moment from 'moment'

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const Description = styled.p`
  color: #5a5a5a;
  font-size: 1rem;
  margin-bottom: 32px;
  
  span {
    font-family: ${props => props.theme.font.primary};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`;

const CancelButton = styled(Button)`
  color: #FFF;
  margin: 0;
  margin-left: 16px;
`;

const ReactivateButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
`;

const CancelAccount = (props) => {
  const { user, updateUser } = useContext(AuthContext);
  // const { openSnackbar } = useContext(DashboardContext);
  const [ cancelModal, updateCancelModal ] = useState(false)
  const [ reactivateModal, updateReactivateModal ] = useState(false)

  const handleCancel = () => {
    cancelPortalUser(user.id, moment.utc(user.billing_date).format('YYYY-MM-DD'))
      .then(() => {
        let newUser = Object.assign({}, user)
        newUser.end_date = user.billing_date
        updateCancelModal(false)
        updateUser(newUser)     
      })
  }

  const handleReactivate = () => {
    reactivatePortalUser(user.id)
      .then(() => {
        let newUser = Object.assign({}, user)
        newUser.end_date = null
        updateReactivateModal(false)
        updateUser(newUser)      
      })
  }

  return (
    <React.Fragment>
      <Container className={props.className}>
        <Label>
          <Cancel /> Cancel Portal Account
        </Label>
        <Description>
          At Avatar Nutrition, your business is earned and will never be taken for granted. While many companies make it hard to cancel a subscription, with Avatar, all you need to do is click the button below. But if you’re not happy with our service, please consider contacting us before you cancel so we can work to correct the problem!
        </Description>
        <ButtonContainer>
          {user.end_date ?
            <ReactivateButton 
              label="Reactivate Account"
              onClick={() => updateReactivateModal(true)}
            />
          :
            <CancelButton 
              label="Cancel Account"
              onClick={() => updateCancelModal(true)}
              warning={true}
            />
          }
        </ButtonContainer>
        <Modal
          warning
          title="Are you sure you want to cancel?"
          message="Are you sure you want to cancel? By clicking 'confirm' you are deleting your portal manager account and all profiles associated with it. Canceling your portal account will revoke access to Avatar Nutrition for all users registered under this account after your current billing date."
          submitLabel="Confirm"
          open={cancelModal}
          onClose={() => updateCancelModal(false)}
          handleSubmit={handleCancel}
        />
        <Modal
          title="Are you sure you want to reactivate?"
          message="This will undo the cancellation and your account will remain active."
          submitLabel="Confirm"
          open={reactivateModal}
          onClose={() => updateReactivateModal(false)}
          handleSubmit={handleReactivate}
        />
      </Container>
  </React.Fragment>
  )
}

export default CancelAccount